export default __webpack_public_path__ + "7ba10d524fdfcb86b0e4544722ed9e4c.png";